// extracted by mini-css-extract-plugin
export var printerCard = "_fy-1";
export var printerCardConfigured = "_fy-2";
export var printerCardError = "_fy-3";
export var printerCardsContainer = "_fy-0";
export var printerIcon = "_fy-8";
export var printerIconConfigured = "_fy-5";
export var printerIconContainer = "_fy-4";
export var printerIconError = "_fy-6";
export var printerIconUnconfigured = "_fy-7";
export var workstationsTableCard = "_fy-9";